import "vuetify/styles"
import { createVuetify } from "vuetify"
import * as allThemes from "@/theme/themes"
import { aliases, sets, defaultSet } from "@/theme/iconSet"

export default createVuetify({
  theme: {
    defaultTheme: "novaLightTheme",
    themes: { ...allThemes },
  },
  icons: {
    defaultSet: defaultSet,
    aliases: aliases,
    sets: {
      ...sets,
    },
  },
})
